import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ui-sidebar',
    templateUrl: './ui-sidebar.component.html',
    styleUrls: ['./ui-sidebar.component.scss'],
    standalone: false
})
export class UiSidebarComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
